module.exports = __webpack_public_path__ + "img/46-0b8869.png";